<template>
  <div class='dataContainer'>    
    <MainNav></MainNav>               
    <router-view></router-view>
    <InfoMessage></InfoMessage> 
  </div>
</template>

<script>
export default {  
  data: function () {     
    return {

    }
  }
}
</script>

<style scoped>
  .dataContainer{
       width:1100px;
       margin-left: 0px;
       font-family: 'Oswald', sans-serif;       
       font-weight: 200;
   }
   @media screen and (max-width: 981px) {       
     .dataContainer{
        width:99%;
     }
   }

</style>
 


// WEBPACK FOOTER //
// App.vue?39f5c74e